/**
 * Sprayo CRO — quick add on a product card.
 *
 * The card is a link to the product page; this button sits on top of it and
 * adds a single bottle without leaving the page. Delegated from the document
 * so cards rendered later — a section reload in the theme editor, say — work
 * without rebinding.
 */
(function () {
  /* Loaded by the homepage product section and by the cart drawer. Both can
     be on one page, and two document listeners would add two bottles per
     press. */
  if (window.__sprayoQuickAdd) return;
  window.__sprayoQuickAdd = true;

  const RESET_AFTER = 2200;

  async function add(button) {
    const variantId = button.dataset.variantId;
    if (!variantId || button.dataset.busy === "true") return;

    button.dataset.busy = "true";
    button.classList.add("is-loading");

    try {
      const addUrl = (window.routes && window.routes.cart_add_url) || "/cart/add";
      const res = await fetch(addUrl + ".js", {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/javascript" },
        body: JSON.stringify({
          items: [{ id: Number(variantId), quantity: 1 }],
          sections: "cart-drawer,cart-icon-bubble",
          sections_url: window.location.pathname,
        }),
      });
      const body = await res.json();

      if (!res.ok || body.status) {
        button.classList.add("is-error");
        setTimeout(() => button.classList.remove("is-error"), RESET_AFTER);
        return;
      }

      refreshCart(body);
      if (window.publish && window.PUB_SUB_EVENTS) {
        window.publish(window.PUB_SUB_EVENTS.cartUpdate, {
          source: "sprayo-quickadd",
          cartData: body,
        });
      }

      confirmAdd(button);
    } catch (error) {
      console.error("[sprayo] quick add failed", error);
      button.classList.add("is-error");
      setTimeout(() => button.classList.remove("is-error"), RESET_AFTER);
    } finally {
      button.dataset.busy = "false";
      button.classList.remove("is-loading");
    }
  }

  /* The label swaps rather than a toast appearing: the confirmation belongs
     on the thing that was pressed, and the drawer opening says the rest. */
  function confirmAdd(button) {
    const label = button.querySelector(".sprayo-products__quickadd__label");
    if (!label) return;
    if (!button.dataset.restoreLabel) button.dataset.restoreLabel = label.textContent;

    label.textContent = button.dataset.addedLabel || "Added";
    button.classList.add("is-added");

    clearTimeout(button._sprayoReset);
    button._sprayoReset = setTimeout(() => {
      label.textContent = button.dataset.restoreLabel;
      button.classList.remove("is-added");
    }, RESET_AFTER);
  }

  function refreshCart(body) {
    const drawer = document.querySelector("cart-drawer");
    if (drawer && body.sections) {
      /* renderContents TOGGLES the drawer, so an already-open one would close
         on add. Same guard the buy box uses. */
      const isClosed = !document.body.classList.contains("page-overlay-cart-on");
      drawer.renderContents({ sections: body.sections }, isClosed);
    } else {
      document.dispatchEvent(new CustomEvent("cart-drawer:refresh"));
    }
  }

  document.addEventListener("click", (event) => {
    const button = event.target.closest("[data-sprayo-quickadd]");
    if (!button) return;
    /* The card underneath is a link; without this the press adds to the cart
       and then navigates away from the drawer it just opened. */
    event.preventDefault();
    event.stopPropagation();
    add(button);
  });
})();
